import { render, staticRenderFns } from "./VeriCodeLogin.vue?vue&type=template&id=8cc1d506&scoped=true&"
import script from "./VeriCodeLogin.vue?vue&type=script&lang=js&"
export * from "./VeriCodeLogin.vue?vue&type=script&lang=js&"
import style0 from "./VeriCodeLogin.vue?vue&type=style&index=0&id=8cc1d506&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cc1d506",
  null
  
)

export default component.exports